import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';
import { ConstantsService } from './constants.service';
import { UserService } from './user.service';

@Injectable({ providedIn: 'root' })
export class SocketService {
    socket: WebSocket | any;
    // events = {
    //     refreshUserPayment = new Subject<any>(null),
    // };

    refreshUserPayment = new Subject<boolean>();


    shouldConnectAgain = true;

    registeredEvents = [];

    constructor(private authService: AuthService,
                private cs: ConstantsService,
                private userService: UserService) {
    }

    getConnection(userId: string) {
        let localData = this.userService.getAMUserFromLocalStorage(environment.crypto.passJWT);
        if (!localData) return;

        let accessAMToken = localData.amToken;
        let accessToken = localData.accessAMDBToken;

        const socketS = this;
        const ws = new WebSocket(`${environment.MADHURAM_BE_WS_HOST_PORT}?authTokenInfo=${environment.authTokenInfo}&x-am-authorization=${accessAMToken}&x-am-user-authorization=${accessToken}`);
        this.socket = ws;

        function sendRegisterEvent() {
            send(<any>{
                objType: 'REGISTER',
                onEvents: [
                    {
                        eventType: 'INSTANCES',

                        apiPath: environment.USER_PATH,
                        instance: environment.INS,
                        database: environment.DB,
                        collection: 'mp_payment_logs',
                        apiName: 'SCHEMA_POST_BULK_INSERT',
                        getEventData: true,

                        condition: {
                            conditionType: 'RESPONSE',
                            criteria: <any>{
                                // userId,
                                // active: true, // We want created but active false notifications also.
                            },
                        },
                        select: <any>{}, // get everything.

                    },
                    {
                        eventType: 'INSTANCES',

                        apiPath: environment.USER_PATH,
                        instance: environment.INS,
                        database: environment.DB,
                        collection: 'mp_payment_logs',
                        apiName: 'SCHEMA_PUT_UPDATE_BY_ID',
                        getEventData: true,

                        condition: {
                            conditionType: 'RESPONSE',
                            criteria: <any>{
                                // userId,
                                // active: true, // We want created but active false notifications also.
                            },
                        },
                        select: <any>{}, // get everything.

                    },
                    {
                        eventType: 'INSTANCES',

                        apiPath: environment.USER_PATH,
                        instance: environment.INS,
                        database: environment.DB,
                        collection: 'mp_users',
                        apiName: 'SCHEMA_PUT_UPDATE_BY_ID',
                        getEventData: true,

                        condition: {
                            conditionType: 'RESPONSE',
                            criteria: <any>{
                                // userId,
                                // active: true, // We want created but active false notifications also.
                            },
                        },
                        select: <any>{}, // get everything.

                    },
                ],
            });

            // setTimeout(() => {
            //     console.log('unregister');
            //     send({
            //         objType: 'UNREGISTER',
            //         onEvents: [registeredEvents[0].eventId],
            //     });
            // }, 5000);
        }

        function send(data: any) {
            ws.send(JSON.stringify(data));
        }

        ws.onopen = function () {
            socketS.registeredEvents = []; // Reset
        };

        ws.onmessage = function (event) {
            const serverResp = <any>JSON.parse(event.data);
            let lastNotificationId = null;
            if (serverResp.type === 'NOTIFICATION') {
                const data = serverResp.response.eventData;
               if(data._id === socketS.authService.getUserId()) socketS.userService.gUser.next({ action: 'REFRESH_G_USER' });
                if (data.mpl_customer_objid === socketS.authService.getUserId() && data._id !== lastNotificationId) {
                    lastNotificationId = data._id;
                    data.type = 'NOTIFICATION';
                    socketS.refreshUserPayment.next(data);
                    socketS.userService.gUser.next({ action: 'REFRESH_G_USER' });
                }
            }

            if (serverResp.type === 'CONNECTED' && serverResp.response.connected) sendRegisterEvent();
            if (serverResp.validOnEvents && serverResp.validOnEvents.length) {
                for (const validEvent of <any>serverResp.validOnEvents) {
                    // @ts-ignore
                    socketS.registeredEvents.push(validEvent);
                }
            }
        };

        ws.onclose = (event) => {
            // if (this.shouldConnectAgain) {
            setTimeout(() => {
                this.getConnection(userId);
            }, 5000);
            // }
        };
    }

    disconnect() {
        this.shouldConnectAgain = false;
        this.socket.close(1000, 'Deliberate Connection');
        setTimeout(() => {
            this.shouldConnectAgain = true;
        }, 2000);
    }
}
